
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData, postData, updateData, uploadImage } from "../../../services/api";
import { hideAddBlogModal } from "./blogModalDispatcher";

  

  export const addBlogRequest = (data, navigate) => {
    return async (dispatch) => {
  
      // dispatch();
      dispatch({"type":"ADD_BLOG_REQUEST"});
      try {
  
    
        if (data.image) {
          var uploadedImage = await uploadImage(
            ApiURLs.UPLOAD_IMAGE, "image",
            data.image,
            "blogs"
          );
          console.log(`upload image function response ${JSON.stringify(uploadedImage)}`)
          data.image_url = uploadedImage.data.file.path
        }



        var blogResponse = (data.id)? await updateData(data, `${ApiURLs.BLOG}/${data.id}`):await postData(data, ApiURLs.BLOG);
        if (blogResponse.status === 1) {
          dispatch({"type":"ADD_BLOG_SUCCESS"});
          dispatch(hideAddBlogModal());
          dispatch(blogLisitingRequest(data["parent_id"]));
        } else {
          dispatch({"type":"ADD_BLOG_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"ADD_BLOG_FAILED"});
  
      }
    };
  };




  export const blogLisitingRequest = (page=1,pageSize=10) => {

    return async (dispatch) => {

      
      const url = `${ApiURLs.BLOG}?offset=${page}&limit=${pageSize}`;
  
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_BLOG_REQUEST"});
      try {
        var blogResData = await fetchData(url);
        console.log(`response when we try to login ${JSON.stringify(blogResData)}`)
        if (blogResData.status === 1) {
          dispatch({"type":"GET_BLOG_REQUEST_SUCCESS", "payload":blogResData.data.result,"total":blogResData.data.total});
        
        } else {
          dispatch({"type":"GET_BLOG_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_BLOG_REQUEST_FAILED"});
        console.log(`error while try to login ${error}`)
      }
    }
  };


  
  export const getBlog = (id) => {

    return async (dispatch) => {
      const url = `${ApiURLs.BLOG}?id=${id}`;
        try {
        var blogData = await fetchData(url);
        console.log(`response when we try to get blog ${JSON.stringify(blogData)}`)
        if (blogData.status === 1) {
         return blogData.data.result;
        
        } else {
          return [];
        }
      } catch (error) {
        console.log(`error while try to get bolgss ${error}`)

        return [];
      }
    }
  };

  


  export const getBlogListing = () => {

    return async (dispatch) => {
      const url = `${ApiURLs.BLOG}`;
        try {
        var blogResData = await fetchData(url);
        console.log(`response when we try to get blog ${JSON.stringify(blogResData)}`)
        if (blogResData.status === 1) {
         return blogResData.data.result;
        } else {
          return [];
        }
      } catch (error) {
        console.log(`error while try to blog ${error}`)

        return [];
      }
    }
  };



    export const deleteBlog = (id, parentId) => {
      return async (dispatch) => {
   
        // dispatch();
        dispatch({"type":"ADD_BLOG_REQUEST"});
        try {
    

          var blogResponse = await deleteData(`${ApiURLs.BLOG}/${id}`);
          if (blogResponse.status === 1) {
            dispatch({"type":"ADD_BLOG_SUCCESS"});
            dispatch(blogLisitingRequest(parentId));
          } else {
            dispatch({"type":"ADD_BLOG_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_BLOG_FAILED"});
        }
      };
    };


  

  

